module.exports = __webpack_public_path__ + "img/e9a3096.jpg";